<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
    <v-dialog v-model="dialog" max-width="520px" persistent>
      <v-card>
        <v-card-title class="text-h5 pa-4">Edit Support Module</v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="moduleName"
              label="Module Name"
              variant="outlined"
              density="compact"
              class="mb-2"
              :rules="[
                (v) => !!String(v || '').trim() || 'Module name is required',
              ]"
            />
            <v-select
              v-model="moduleStatus"
              label="Status"
              :items="statusOptions"
              item-title="title"
              item-value="value"
              variant="outlined"
              density="compact"
              :rules="[(v) => !!v || 'Status is required']"
            />
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" variant="text" @click="handleClose">Cancel</v-btn>
          <v-btn
            color="primary"
            variant="flat"
            :disabled="loading"
            :loading="loading"
            @click="handleSubmit"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { edit_support_module_masters } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: "EditModule",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    module_id: {
      type: String,
      default: "",
    },
    module_name: {
      type: String,
      default: "",
    },
    module_status: {
      type: String,
      default: "ACTIVE",
    },
  },
  emits: ["update:modelValue", "updated"],
  data() {
    return {
      valid: false,
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
      moduleName: "",
      moduleStatus: "ACTIVE",
      statusOptions: [
        { title: "Active", value: "ACTIVE" },
        { title: "Inactive", value: "DEACTIVE" },
      ],
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(newVal) {
      if (newVal) {
        this.moduleName = this.module_name || "";
        this.moduleStatus =
          String(this.module_status || "ACTIVE").toUpperCase() === "DEACTIVE"
            ? "DEACTIVE"
            : "ACTIVE";
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
        });
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.moduleName = "";
      this.moduleStatus = "ACTIVE";
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async handleSubmit() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) {
        return;
      }

      this.loading = true;
      try {
        const response = await client.graphql({
          query: edit_support_module_masters,
          variables: {
            input: {
              module_id: this.module_id,
              module_name: this.moduleName.trim(),
              module_status: this.moduleStatus,
            },
          },
        });
        const rawPayload = response.data.edit_support_module_masters;
        const responseData =
          typeof rawPayload === "string" ? JSON.parse(rawPayload) : rawPayload;
        if (responseData.success === true || responseData.status == "SUCCESS") {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              (typeof responseData.message === "string"
                ? responseData.message
                : "") ||
              "Support module updated successfully",
            color: "success",
          };
          this.$emit("updated");
          this.handleClose();
        } else {
          this.loading = false;
          this.snackbar = {
            show: true,
            message:
              responseData.status_message ||
              (typeof responseData.message === "string"
                ? responseData.message
                : "") ||
              "Failed to update module",
            color: "error",
          };
        }
      } catch (error) {
        this.loading = false;
        console.error("Error updating support module:", error);
        this.snackbar = {
          show: true,
          message:
            (typeof error?.message === "string" && error.message) ||
            "Failed to update module",
          color: "error",
        };
      }
    },
  },
};
</script>

<style scoped></style>
